var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconInfo = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.827 2a3.146 3.146 0 0 0-3.143 3.143v15.714A3.146 3.146 0 0 0 5.827 24H21.54a3.146 3.146 0 0 0 3.143-3.143V5.143A3.146 3.146 0 0 0 21.541 2H5.827zm5.893 14.929h1.178v-3.143H11.72a1.176 1.176 0 0 1-1.179-1.179c0-.653.526-1.178 1.179-1.178h2.357c.653 0 1.178.525 1.178 1.178v4.322h.393c.653 0 1.179.525 1.179 1.178 0 .653-.526 1.179-1.179 1.179H11.72a1.176 1.176 0 0 1-1.179-1.179c0-.653.526-1.178 1.179-1.178zm1.964-10.215a1.571 1.571 0 1 1 0 3.143 1.571 1.571 0 0 1 0-3.143z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-info.6c5553f2.svg";
export { ForwardRef as ReactComponent };